// 格式化日期 前台传值方式  引用类.dateFormat(1402233166999,"yyyy-MM-dd hh:mm:ss")
/**
 * @name: 格式化日期
 * @param {*} value 可传入时间戳或Date类型
 * @param {*} fmt 要输出的格式 默认 yyyy-MM-dd hh:mm:ss
 * @return {*}
 */
export const dateFormat = (value, fmt = 'yyyy-MM-dd hh:mm:ss') => {
  if (!value) {
    return '--';
  }
  let getDate = ['string', 'number'].includes(typeof value) ? new Date(value) : value;
  let o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'h+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3),
    S: getDate.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return fmt;
};

export const calcDate = (date1, date2) => {
  let date3 = date2 - date1;

  let days = Math.floor(date3 / (24 * 3600 * 1000));

  let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000));

  let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000));

  let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  let seconds = Math.round(date3 / 1000);
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
};

/**
 * @name: 拷贝对象
 * @param {*} copyObj
 * @return {*}
 */
export const copyObj = obj => {
  return JSON.parse(JSON.stringify(obj));
};

/**
 * 深拷贝
 */
export const deepCopy = obj => {
  if (obj === null || typeof obj !== 'object') {
    // 如果是基本数据类型或 null，直接返回
    return obj;
  }

  if (Array.isArray(obj)) {
    // 如果是数组，创建一个新的数组并递归复制每个元素
    const newArray = [];
    for (let i = 0; i < obj.length; i++) {
      newArray[i] = deepCopy(obj[i]);
    }
    return newArray;
  }

  // 如果是对象，创建一个新的对象并递归复制每个属性
  const newObj = {};
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepCopy(obj[key]);
    }
  }
  return newObj;
};

export const testMobile = val => {
  return /^1[23456789]\d{9}$/.test(val);
};

/**
 * 字符串加密与解密方法
 */
export const encryption = {
  // 加密
  compile: code => {
    if (!code) return '';
    let c = String.fromCharCode(code.charCodeAt(0) + code.length);
    for (let i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
    }
    return escape(c);
  },
  // 解密
  uncompile: code => {
    if (!code) return '';
    code = unescape(code);
    let c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for (let i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
  },
};

/**
 *
 * @param {*fn} fn 要执行的函数
 * @param {*gapTime} gapTime 间隔时间
 * @description 节流函数，防重复点击可用
 */
export const throttle = function (fn, gapTime) {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 400;
  }
  let lastTime = 0;
  // 返回新的函数
  return function () {
    let nowTime = new Date().getTime();
    if (nowTime - lastTime > gapTime) {
      fn.apply(this, arguments);
      lastTime = nowTime;
    }
  };
};

/**
 * @param {*fn} fn 要执行的函数
 * @param {*wait} wait 等待时间
 * @param {*immediate} immediate 是否立即执行
 * @description 防抖函数
 */
export const debounce = function (func, wait, immediate) {
  if(!wait){
    wait = 400
  }
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// 复制
export const copy = copyText => {
  var input = document.createElement('input'); // 直接构建input
  input.value = copyText; // 设置内容
  document.body.appendChild(input); // 添加临时实例
  input.select(); // 选择实例内容
  document.execCommand('Copy'); // 执行复制
  document.body.removeChild(input); // 删除临时实例
};

/**
 * url参数拼接
 * @param obj
 * @returns string
 */
export const urlParamsJoin = obj => {
  let keys = Object.keys(obj);
  let url = '';
  for (let i = 0; i < keys.length; i++) {
    if (i === 0) {
      url += '?' + keys[i] + '=' + obj[keys[i]];
    } else {
      url += '&' + keys[i] + '=' + obj[keys[i]];
    }
  }
  return url;
};

// 将base64转换为文件对象
export const base64toFile = (dataurl, filename) => {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  // 转换成file对象
  return new File([u8arr], filename, { type: mime });
};

// 深拷贝
export const deepClone = obj => {
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === 'object') {
    for (let key in obj) {
      // eslint-disable-next-line
      if (obj.hasOwnProperty(key)) {
        // 判断ojb子元素是否为对象，如果是，递归复制
        if (obj[key] && typeof obj[key] === 'object') {
          objClone[key] = deepClone(obj[key]);
        } else {
          // 如果不是，简单复制
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
};

/**
 * 对象转url拼接参数
 */
export const objectToUrlParams = obj => {
  if (obj === '{}' || JSON.stringify(obj) === '{}') return '';
  var params = [];

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var value = obj[key];

      // 如果属性值是数组，则将每个元素都进行编码并拼接到参数中
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          params.push(encodeURIComponent(key) + '=' + encodeURIComponent(item));
        });
      } else {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
  }

  return '?' + params.join('&');
};

/**
 * @name 获取url请求参数
 * @param {string} search
 */
export const getURLSearchParams = () => {
  let ret = {};
  const arr = window.location.href.split('?');
  if (arr[1]) {
    let searchParams = new URLSearchParams(arr[1]);
    for (let [key, value] of searchParams) {
      ret[key] = value;
    }
  }

  return ret;
};

// 动态插入js文件
let scriptDataList = [];
export function insertScript(id, url) {
  const scriptData = scriptDataList.find(item => item.id === id);
  if (scriptData) {
    return scriptData.promise;
  }
  const promise = new Promise(function (resolve, reject) {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'text/javascript';
      el.src = url;
      document.documentElement.appendChild(el);
    } else {
      resolve();
    }
    el.onload = function () {
      resolve();
    };
    el.onerror = function (msg) {
      reject(new Error(msg));
    };
  });
  return promise;
}

export function findTreeObject(tree, identity, identityProp = 'id', childrenProp = 'children', parentList = []) {
  for (const item of tree) {
    if (item[identityProp] === identity) {
      return item;
    } else if (item[childrenProp]?.length) {
      const child = findTreeObject(item[childrenProp], identity, identityProp, childrenProp, parentList);
      if (child) {
        parentList.splice(0, 0, item);
        return child;
      }
    } else {
      //
    }
  }
  return null;
}
